@if (dashboardModel.analyticsVisible) {
  <div class="analytics-dashboard">
    <header class="analytics-dashboard__intro">
      <div>
        <p class="analytics-dashboard__eyebrow">DevAdmin Analytics</p>
        <h2 class="analytics-dashboard__title">Platform at a glance</h2>
        <p class="analytics-dashboard__subtitle">Live counts across users, programs, content, and invitations.</p>
      </div>
    </header>

    @if (platformMetrics.length) {
      <section
        class="analytics-dashboard__stats-row"
        [class.analytics-dashboard__stats-row--compact]="platformMetrics.length <= 3"
        aria-label="Platform metrics">
        @for (metric of platformMetrics; track metric.label) {
          <article
            class="stat-tile"
            [class]="'stat-tile stat-tile--' + metric.accent">
            <div class="stat-tile__body">
              <span class="stat-tile__value">{{ metric.getValue(dashboardModel.analytics) | number }}</span>
              <span class="stat-tile__label">{{ metric.label }}</span>
            </div>
            <mat-icon class="stat-tile__icon">{{ metric.icon }}</mat-icon>
          </article>
        }
      </section>
    }

    @if (showBbInvitations || showLlttfInvitations) {
      <div class="analytics-dashboard__divider" role="separator">
        <span>Invitations</span>
        <span class="analytics-dashboard__divider-meta">Last 4 weeks</span>
      </div>

      <section class="analytics-dashboard__invitations" aria-label="Invitation status">
        @if (showBbInvitations) {
          <article class="invitation-card">
            <header class="invitation-card__head">
              <div>
                <h3 class="invitation-card__title">BB invitations</h3>
                <p class="invitation-card__subtitle">BounceBack program</p>
              </div>
              <mat-icon class="invitation-card__icon" aria-hidden="true">outgoing_mail</mat-icon>
            </header>
            <div class="invitation-card__metrics">
              @for (metric of bbInvitationMetrics; track metric.label) {
                <div
                  class="invitation-stat"
                  [class]="'invitation-stat invitation-stat--' + metric.tone">
                  <span class="invitation-stat__value">{{ metric.getValue() | number }}</span>
                  <span class="invitation-stat__label">{{ metric.label }}</span>
                </div>
              }
            </div>
          </article>
        }

        @if (showLlttfInvitations) {
          <article class="invitation-card">
            <header class="invitation-card__head">
              <div>
                <h3 class="invitation-card__title">LLTTF invitations</h3>
                <p class="invitation-card__subtitle">Living Life to the Full</p>
              </div>
              <mat-icon class="invitation-card__icon" aria-hidden="true">diversity_3</mat-icon>
            </header>
            <div class="invitation-card__metrics">
              @for (metric of llttfInvitationMetrics; track metric.label) {
                <div
                  class="invitation-stat"
                  [class]="'invitation-stat invitation-stat--' + metric.tone">
                  <span class="invitation-stat__value">{{ metric.getValue() | number }}</span>
                  <span class="invitation-stat__label">{{ metric.label }}</span>
                </div>
              }
            </div>
          </article>
        }
      </section>
    }

    @if (showBbGrowth) {
      <div class="analytics-dashboard__divider" role="separator">
        <span>Participant growth</span>
      </div>

      <section class="growth-panel" aria-label="Participant growth">
        <div class="growth-panel__content">
          <h3 class="growth-panel__title">New BB coached participants</h3>
          <div class="growth-panel__periods" role="group" aria-label="Time period">
            @for (option of periodOptions; track option.value) {
              <button
                type="button"
                class="growth-panel__period"
                [class.growth-panel__period--active]="drpCoachParticipantValue === option.value"
                (click)="setPeriod(option.value)">
                {{ option.label }}
              </button>
            }
          </div>
          @if (showGrowthEmptyHint) {
            <p class="growth-panel__hint">No participants — try a longer range</p>
          }
        </div>
        <div class="growth-panel__stat">
          <span class="growth-panel__value">{{ coachedParticipantCount | number }}</span>
        </div>
      </section>
    }
  </div>
}
